import {GIFTING_OPEN_EVENT_TYPES} from './giftingOpenEventTypes';

export {GIFTING_OPEN_EVENT_TYPES};

export const EVENT_REMINDER_PRIMARY_CHOICES = [
  ['-86400', '1 Day'],
  ['-172800', '2 Days'],
  ['-259200', '3 Days'],
  ['-345600', '4 Days'],
  ['-432000', '5 Days'],
  ['-518400', '6 Days'],
  ['-604800', '7 Days'],
  ['-691200', '8 Days'],
  ['-777600', '9 Days'],
  ['-864000', '10 Days'],
  ['-1209600', '2 Weeks'],
  ['-1814400', '3 Weeks'],
  ['-2592000', '1 Month'],
];
export const EVENT_REMINDER_NONPRIMARY_CHOICES = [['0', '---']].concat(
  EVENT_REMINDER_PRIMARY_CHOICES
);

export const CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 9998,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
  },
};

export const MOBILE_STYLES = {
  overlay: {},
  content: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0,
    zIndex: 9999,
  },
};

export const UNTITLED_EVENT = 'Untitled Event';
export const UNTITLED_CARD = 'Untitled Card';
export const CARD = 'card';
export const MAX_GUEST = 10000; // TODO should the backend provide this?
export const PREMIUM_GUEST_LIMIT = 2500;
export const FREE_GUEST_LIMIT = 750;
export const INVITATION_OFFER_LIST = 'current_invitation_pricing';
// Unlimited guests A/B test
export const FREE_EVENT_GUESTS_LOWER_LIMIT = 50;
export const FREE_EVENT_GUESTS_UPPER_LIMIT = 750;
export const UNLIMITED_GUESTS_OFFERS_LIST_NAME = 'free_max_guestlist_pricing';
export const UNLIMITED_GUESTS_OFFER_ID = 'unlimited_guest_51_to_750';
export const ALTERNATIVE_INVITATION_OFFER_LISTS = [UNLIMITED_GUESTS_OFFERS_LIST_NAME];
